import { Grid, Typography, Divider } from "@mui/material";
import AcxMainTextField from "components/UI/AcxMainTextField";
import moment from "moment";
import React, { useState } from "react";
import { LightGrayBackground } from "../LightGrayBackground";
import { ResultBadge } from "./ResultBadge";
import { TitledDrawer } from "./TitledDrawer";
import { useStore } from "utils/useStore";
import { LLMClassifierBuilderStore } from "../../Stores/LLMClassifierBuilderStore";
import AcxButton from "components/UI/AcxButton";
import { LabeledConversation } from "models/LLMs/Testing/TestLLMClassifierAgreementResult";

interface ViewLabelingProps {
    conversation: LabeledConversation;
}

export function ViewLabeling(props: ViewLabelingProps) {
    const store = useStore(LLMClassifierBuilderStore);
    const [isNotesDrawerOpen, setIsNotesDrawerOpen] = useState(false);

    return (
        <React.Fragment>
            <AcxButton color="white" onClick={() => setIsNotesDrawerOpen(true)}>
                View Labeling
            </AcxButton>
            <TitledDrawer
                title="Notes and Clips"
                open={isNotesDrawerOpen}
                onClose={() => setIsNotesDrawerOpen(false)}
            >
                <TitledDrawer.Section>
                    <Grid item>
                        <Typography
                            sx={(theme) => ({
                                fontWeight: 600,
                                fontSize: "14px",
                                lineHeight: "20px",
                                color: theme.palette.gray[700],
                            })}
                        >
                            {props.conversation.questionText}
                        </Typography>
                    </Grid>
                    <Grid item>
                        Labeled:{" "}
                        <ResultBadge
                            color={store.getResultColor(
                                props.conversation.labeled,
                            )}
                        >
                            {props.conversation.labeled}
                        </ResultBadge>
                    </Grid>
                    <Grid container item direction="column" rowGap={1}>
                        {props.conversation.answerNotes && (
                            <Grid item>
                                <Typography
                                    component="span"
                                    sx={(theme) => ({
                                        fontWeight: 600,
                                        fontSize: "14px",
                                        lineHeight: "20px",
                                        color: theme.palette.gray[700],
                                    })}
                                >
                                    {props.conversation.answerModifiedBy}
                                </Typography>{" "}
                                <Typography component="span">
                                    left a note
                                </Typography>
                            </Grid>
                        )}
                        <Grid item>
                            <AcxMainTextField
                                id=""
                                value={props.conversation.answerNotes ?? ""}
                                placeholderText="No note"
                                multiline
                                multilinePadding
                                rowsMin={3}
                                rowsMax={3}
                            />
                        </Grid>
                        <Grid item>
                            <Typography
                                sx={(theme) => ({
                                    fontSize: "12px",
                                    lineheight: "16px",
                                    color: theme.palette.gray[500],
                                })}
                            >
                                {moment
                                    .utc(props.conversation.answerModifiedOn)
                                    .local()
                                    .format("MMM D [at] h:mm A")}
                            </Typography>
                        </Grid>
                    </Grid>
                </TitledDrawer.Section>
                <Grid item>
                    <Divider />
                </Grid>
                <TitledDrawer.Section>
                    <Grid item>
                        <Typography
                            sx={(theme) => ({
                                fontWeight: 600,
                                fontSize: "14px",
                                lineHeight: "20px",
                                color: theme.palette.gray[700],
                            })}
                        >
                            Clips
                        </Typography>
                    </Grid>
                    {props.conversation.soundClips &&
                        props.conversation.soundClips.map((clip) => {
                            return (
                                <Grid
                                    container
                                    item
                                    direction="column"
                                    rowGap={1}
                                    flexWrap="nowrap"
                                >
                                    <Grid item>
                                        <Typography
                                            component="span"
                                            sx={(theme) => ({
                                                color: theme.palette.gray[700],
                                            })}
                                        >
                                            Tag:
                                        </Typography>{" "}
                                        <ResultBadge
                                            color={store.getResultColor(
                                                clip.tag,
                                            )}
                                        >
                                            {clip.tag}
                                        </ResultBadge>
                                    </Grid>
                                    <Grid item>
                                        <Typography
                                            sx={(theme) => ({
                                                fontWeight: 600,
                                                fontSize: "12px",
                                                lineHeight: "20px",
                                                color: theme.palette.primary
                                                    .main,
                                            })}
                                        >
                                            {clip.name}
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <LightGrayBackground
                                            sx={(theme) => ({
                                                backgroundColor:
                                                    theme.palette.gray[50],
                                                borderRadius: "8px",
                                            })}
                                        >
                                            {clip.transcriptionText}
                                        </LightGrayBackground>
                                    </Grid>
                                </Grid>
                            );
                        })}
                    {!props.conversation.soundClips && (
                        <Grid item>
                            <Typography>No associated clips</Typography>
                        </Grid>
                    )}
                </TitledDrawer.Section>
            </TitledDrawer>
        </React.Fragment>
    );
}
